import axios from "axios";
const baseUrl = `${process.env.REACT_APP_PLUTUS_BACKEND_HOST}`;
// const baseUrl = `http://localhost:8000`;

const readMemberList = async (param) => {
	const { data } = await axios.get(`${baseUrl}/user/list/admin`, {
		params: param,
	});
	return data;
};

const readLonglifeUserList = async (param) => {
	const { data } = await axios.get(`${baseUrl}/longlifeuser/list`, {
		params: param,
	});
	return data;
};

const readLonglifeExpertList = async (param) => {
	const { data } = await axios.get(`${baseUrl}/longlifeuser/expertList`, {
		params: param,
	});
	return data;
};

const readMemberPointHistoryList = async (userId) => {
	const { data } = await axios.get(
		`${baseUrl}/point/point/history/search?user_id=${userId}`
	);
	return data;
};

const earnPointForMember = async (param) => {
	const { data } = await axios.post(`${baseUrl}/point/admin/earn`, param);
	return data;
};

const sendPushForLonglife = async (param) => {
	const { data } = await axios.post(`${baseUrl}/longlife/push/send`, param);
	return data;
};

const getMenuList = async (param) => {
	const { data } = await axios.get(`${baseUrl}/plutusUsers/menu`, {
		params: param,
	});
	return data;
};

const plutusApi = {
	readMemberList,
	readLonglifeUserList,
	readLonglifeExpertList,
	readMemberPointHistoryList,
	earnPointForMember,
	sendPushForLonglife,
	getMenuList,
};

export default plutusApi;
